import axios from "axios";
import {
  browserName,
  fullBrowserVersion,
  isEdge,
  isOpera,
  isSafari,
  isFirefox,
  isChrome
} from "react-device-detect";
import { apiEndPointConstant } from "../../statics/constants";
import { axiosInstance } from "../config/configApi";

let terminalOsType = null;
switch (true) {
  case isChrome:
    terminalOsType = "WebChrome";
    break;
  case isSafari:
    terminalOsType = "WebSafari";
    break;
  case isEdge:
    terminalOsType = "WebEdge";
    break;
  case isFirefox:
    terminalOsType = "WebChrome";
    break;
  case isOpera:
    terminalOsType = "WebChrome";
    break;
  default:
    terminalOsType = "Web";
    break;
}

const getLoginToken = async (userName, password) => {
  return await axiosInstance.post(
    apiEndPointConstant.authClient + "/user/login",
    {
      username: userName,
      password: password
    },
    {
      skipAuth: true,
      headers: {
        "Device-Type": terminalOsType
      }
    }
  );
};

const sendMePassword = async (phoneNumber) => {
  return await axios.post("/messageEndpoint", {
    params: {
      phoneNumber: phoneNumber
    }
  });
};

const emailResetPassword = async (email) => {
  return await axios.post(apiEndPointConstant.authClient + "/user/forgot-password", null, {
    params: {
      email: email
    }
  });
}

const resetPassword = async (token, password) => {
  return await axios.post(apiEndPointConstant.authClient + "/user/forgot-password-change", {
    token: token,
    password: password
  });
}

export { getLoginToken, sendMePassword, emailResetPassword, resetPassword };